export default [
  {
    header: 'Pages',
    icon: 'FileIcon',
    children: [
      {
        title: 'Home',
        route: 'home-dashboard',
        icon: 'HomeIcon',
      }
    ],
  },
]
